export const navLinksLeft = [
  { name: 'Home', href: '/' },
  { name: 'About', href: '/about' },
  { name: 'Services', href: '/services' },
  { name: 'Websites', href: '/websites' },
  { name: 'Process', href: '/process' },
];

export const navLinksRight = [];

export const allMenuLinks = [
  { number: '01', name: 'Home', href: '/' },
  { number: '02', name: 'About', href: '/about' },
  { number: '03', name: 'Services', href: '/services' },
  { number: '04', name: 'Websites', href: '/websites' },
  { number: '05', name: 'Process', href: '/process' },
  // { number: '06', name: 'Blog', href: '/blog' },
  { number: '06', name: 'Inquire', href: '/inquiry' },
];

export const socialLinks = [
  { name: 'Instagram', href: 'https://www.instagram.com/seasalt_creative/' },
  { name: 'Pinterest', href: 'https://pinterest.com' },
  { name: 'LinkedIn', href: 'https://linkedin.com' },
  { name: 'hello@seasaltcreative.com', href: 'mailto:hello@seasaltcreative.com' },
];
